import { Paper} from '@mui/material'
import custom from '../../styles/mui/szVariables.json'

export default function ClickableCard({ 
        id, 
        height,
        px,py,
        handleCardClick, 
        children 
    }: any) {

    return (
        <Paper id={id} elevation={0} 
            sx={{ 
                boxSizing: 'border-box',
                height,
                width: "100%",
                minWidth: '155px',
                px,py,
                border: custom.border, 
                borderRadius: custom.corners5, 
                "&:hover": { boxShadow: 6 },
                [`&:hover #${id}hoverIcon`]: { 
                    visibility: 'visible'
                },
                cursor: 'pointer',
            }}  
            onClick={handleCardClick} >
             {children}
        </Paper>
    )
}